import http from '@/services/rest/rest.service';
import { ISearchBody, ISortBody } from '@/entities/search-body.interface';
import { IAccount } from '@/entities/accounts/account.interface';
import {
    ISiteManualModel,
    IListItem,
    ISiteManualUpdateModel,
    ISiteManualListModel,
    ISiteManualDetailModel
} from '@/entities';

export default {
    list(sortBody: ISortBody): Promise<ISiteManualListModel[]> {
        return http.get('site-manuals', sortBody);
    },
    get(id: number): Promise<ISiteManualDetailModel> {
        return http.get(`site-manuals/${id}`);
    },
    delete(id: number): Promise<void> {
        return http.delete(`site-manuals/${id}`);
    },
    availableSites(): Promise<IListItem[]> {
        return http.get('site-manuals/available-sites');
    },
    create(model: ISiteManualModel): Promise<number> {
        return http.put('site-manuals', model);
    },
    update(id: number, model: ISiteManualUpdateModel): Promise<number> {
        return http.post(`site-manuals/${id}`, model);
    }
};
